module.exports = __webpack_public_path__ + "static/img/002.b2fa980.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/templates/sotet-konyha/sample-thumbnails/002.jpg
// module id = 859
// module chunks = 0